/* @flow */

import React from 'react'
import { connect } from 'react-redux'

import type { RootState, Dispatch, Poll, PollId } from '../types'

import { selectPollWhereId } from '../stores/pollsStore'
import { fetchIconsIntoStore } from '../sagas/fetchIcons'
import { fetchPollIntoStoreWhereId } from '../sagas/fetchPoll'
import { selectIsFetchingPollWhereId } from '../stores/pending'

import ExistingPollPageAfterFetch from './ExistingPollPageAfterFetch'

type Props = {
  params: {
    pollId: PollId,
  },
  originalPoll: ?Poll,
  isFetchingPoll: boolean,

  fetchIconsIntoStore: () => void,
  fetchPollIntoStoreWhereId: (id: PollId) => void,
}

type OwnProps = {
  params: {
    pollId: PollId,
  },
}

type State = {
  originalPoll: ?Poll,
  isFetchingPoll: boolean,
}

type DispatchProps = {
  fetchIconsIntoStore: () => void,
  fetchPollIntoStoreWhereId: (id: PollId) => void,
}

class ExistingPollPage extends React.Component<Props, State> {
  componentDidMount() {
    this.props.fetchPollIntoStoreWhereId(this.props.params.pollId)
    this.props.fetchIconsIntoStore()
  }

  render() {
    const props = this.props

    if (props.isFetchingPoll) {
      return <div>fetching the newest version of this poll for you.</div>
    }

    if (props.originalPoll == null) {
      return <div>no poll with id {props.params.pollId} exists.</div>
    }

    // only mount the actual poll builder if the poll really exists
    return <ExistingPollPageAfterFetch originalPoll={props.originalPoll} />
  }
}

function mapStateToProps(state: RootState, props: OwnProps): State {
  return {
    originalPoll: selectPollWhereId(state, props.params.pollId),
    isFetchingPoll: selectIsFetchingPollWhereId(state, props.params.pollId),
  }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    fetchIconsIntoStore() {
      dispatch(fetchIconsIntoStore())
    },
    fetchPollIntoStoreWhereId(id: PollId) {
      dispatch(fetchPollIntoStoreWhereId(id))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExistingPollPage)



// WEBPACK FOOTER //
// ./src/components/ExistingPollPage.js